import { render, staticRenderFns } from "./Comercios.vue?vue&type=template&id=4468c6f6&scoped=true&"
import script from "./Comercios.vue?vue&type=script&lang=ts&"
export * from "./Comercios.vue?vue&type=script&lang=ts&"
import style0 from "./Comercios.vue?vue&type=style&index=0&id=4468c6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4468c6f6",
  null
  
)

export default component.exports